import { Fragment, useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectCurrentUser } from "../../../redux/reducers/authSlice";
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation, useParams } from "react-router-dom";
import { Alert, Button, Box, List, ListItem, ListItemText, ListItemIcon, DialogTitle, Dialog, DialogActions, Typography, DialogContent, Grid, Card, CardHeader, CardContent, Snackbar, Switch} from '@mui/material';
import { gridNumberComparator } from '@mui/x-data-grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import BalanceIcon from '@mui/icons-material/Balance';
import PersonIcon from '@mui/icons-material/Person';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import EditIcon from "@mui/icons-material/Edit"
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import PersonasJuridicasTable from './personasTables/PersonasJuridicasTable';
import PersonasHumanasTable from './personasTables/PersonasHumanasTable';
import { getConversionesCAC } from '../../../edilia/index'
import { getPersonasData, addPersona, editPersona, deletePersona, getInfoContratos } from "./personasSlice.js";
import theme from "../../../theme";
import * as _ from 'lodash';

const TIPOS_DNI = {
  "dni": "DNI",
  "pasaporte": "Pasaporte",
  "libreta_enrolamiento": "Libreta de Enrolamiento",
  "libreta_civica": "Libreta Cívica",
};

const moneyFormat = v => '$' + new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'ARS' }).format(parseInt(v) / 100).replace("ARS", "");

function calcularParticipacion(personaId, partesContrato) {
  // Crea un objeto que contendrá el porcentaje de participación de la persona en cada contrato
  const participacion = {};
  // Itera sobre las partes del contrato
  for (const parte of partesContrato) {
    // Si la persona es titular de esta parte del contrato...
    if (parte.personaId === personaId) {
      // Obtiene el ID del contrato
      const contratoId = parte.contratoId;

      // Si aún no se ha calculado la participación de la persona en este contrato...
      if (!(contratoId in participacion)) {
        // Inicializa la participación en null
        participacion[contratoId] = null;
      }

      // Aumenta la participación de la persona en el contrato en la cantidad especificada en la parte del contrato
      participacion[contratoId] += parte.partes;
    }
  }

  // Itera sobre los contratos en los que la persona tiene participación
  for (const contratoId in participacion) {
    // Obtiene el total de partes en el contrato
    const totalPartes = partesContrato
      .filter(parte => parseInt(parte.contratoId) === parseInt(contratoId))
      .reduce((total, parte) => total + parte.partes, 0);

    // Calcula el porcentaje de participación de la persona en el contrato y lo multiplica por 100 para obtener el porcentaje en una escala del 0 al 100
    participacion[contratoId] = (participacion[contratoId] / totalPartes) * 100;
  }

  // Devuelve el objeto con la participación de la persona en cada contrato
  return participacion;
}
function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
};
function getFecha(date) {
  date = new Date(parseInt(date)).toLocaleString().split(",");
  date = date[0].split("/");

  let m = date[1] < 10 ? padTo2Digits(date[1]) : date[1];
  let d = date[0] < 10 ? padTo2Digits(date[0]) : date[0];
  let y = date[2];
  return d + '/' + m + '/' + y
};
const fechaSortComparator = (v1, v2, param1, param2) => {
  function getFechaNumero(date) {
    date = date.split('/')
    let d = date[0] < 10 ? padTo2Digits(date[0]) : date[0];
    let m = date[1] < 10 ? padTo2Digits(date[1]) : date[1];
    let y = date[2];
    var fullDate = y + m + d;
    return parseInt(fullDate);
  }
  let fecha1 = getFechaNumero(param1.value)
  let fecha2 = getFechaNumero(param2.value)
  const ComparatorResult = gridNumberComparator(
    fecha1,
    fecha2,
  );
  if (ComparatorResult !== 0) {
    return ComparatorResult;
  }
  return gridNumberComparator(v1.name, v2.name, param1, param2);
};
const PersonasCat = (props) => {
  const currentUser = useSelector(selectCurrentUser);
  let location = useLocation();

  const [type, setType] = useState();
  const dispatch = useDispatch();
  const { fetching,  message, error } = useSelector(state => state.personas);
  const { contratos, personas, rolesMap, permisos, permisosRolesMap, titularidades, roles, clasesContratos } = useSelector(state => state.personas.data);
  useEffect(() => { dispatch(getPersonasData()) }, []);

  useEffect(() => setType(location.pathname.toLowerCase().split('personas/')[1].split('/')[0]), [location]);

  function getHumanas(personas, wantsDeleted) {
    if (currentUser?.roles?.includes('Vendedor Externo')) {
      let idsFiltroPersonasRol = (rolesMap || [])?.filter(r => r.rolId === 10)?.map(r => r.personaId)
      return (personas || [])?.filter(p => (p.personaFisica && (wantsDeleted ? p.eliminado : !p.eliminado)) && idsFiltroPersonasRol?.includes(p.personaId))
    }
    return (personas || []).filter(p => p.personaFisica && (wantsDeleted ? p.eliminado : !p.eliminado));
  }
  function getJuridicas(personas, wantsDeleted) {
    return (personas || []).filter(p => !p.personaFisica && (wantsDeleted ? p.eliminado : !p.eliminado));
  }
  //A: funciones auxiliares para filtrar por tipo de persona y mostrat eliminados o no

  const [personasHumanas, setPersonasHumanas] = useState([]);
  const [personasJuridicas, setPersonasJuridicas] = useState([]);

  //A: este estado lo usa el datagrid para mostrar las personas segun la pagina donde esta

  useEffect(() => {
    let wantsDeleted = showDeletedUsers;
    if (type === 'juridicas') {
      let personasJuridicas = getJuridicas(personas, wantsDeleted).map(p => {
        let rolesPersona = (rolesMap || [])?.filter(r => r.personaId === p.personaId).map(r => r.rolId);
        let rolesNombres = (roles || [])?.filter(r => rolesPersona?.includes(r.rolId))?.map(r => r.nombre)?.join(', ')
        return ({ ...p, roles: rolesNombres })
      })
      setPersonasJuridicas(personasJuridicas);
    } else {
      let personasHumanas = getHumanas(personas, wantsDeleted).map(p => {
        let rolesPersona = (rolesMap || [])?.filter(r => r.personaId === p.personaId).map(r => r.rolId);
        let rolesNombres = (roles || [])?.filter(r => rolesPersona?.includes(r.rolId))?.map(r => r.nombre)?.join(', ')
        return ({ ...p, roles: rolesNombres })
      })
      setPersonasHumanas(personasHumanas);
    }
  }, [personas, type, roles, rolesMap]);
  //A: cuando carga las personas o cambia el tipo de type filtramos los usarios por tipo y por si esta eliminado o no.


  const [showDeletedUsers, setShowDeletedUsers] = useState(false);
  const handleSwitchChange = (event) => {
    setShowDeletedUsers(event.target.checked);
    if (type === 'juridicas') {
      setPersonasJuridicas(event.target.checked ? getJuridicas(personas, true) : getJuridicas(personas, false));
    } else {
      setPersonasHumanas(event.target.checked ? getHumanas(personas, true) : getHumanas(personas, false));
    }
  };
  //A: cuando se cambia el switch de mostrar eliminados, se cambia el estado y se filtran las personas segun el tipo y si esta eliminado o no

  const [userMoreDetail, setUserMoreDetail] = useState(false); //A: cuando se hace click en el boton de mas detalles, se guarda el usuario en esta variable
  const [userRegisterModal, setUserRegisterModal] = useState(false);
  useEffect(() => { dispatch(getInfoContratos(parseInt(userMoreDetail?.personaId))) }, [userMoreDetail]);
  function getLabel(option) {//U: Used to get the label of the selected option
    if (option.personaFisica) {
      if (!option.nombre && !option.apellido && !option.numeroDocumento) return option.email;
      return option.nombre + ' ' + option.apellido + ' - ' + option.numeroDocumento;
    } else {
      if (!option.denominacionSocial && !option.cuit) return option.email;
      return option.denominacionSocial + ' - ' + option.cuit;
    }
  };
  function getFecha(date) {
    date = new Date(parseInt(date)).toLocaleString().split(",");
    date = date[0].split("/");

    let m = date[1] < 10 ? padTo2Digits(date[1]) : date[1];
    let d = date[0] < 10 ? padTo2Digits(date[0]) : date[0];
    let y = date[2];
    return d + '/' + m + '/' + y
  };
  const getPersonaRolesId = (personaId) => {
    let rolesForUser = (rolesMap || [])?.filter(rolMap => rolMap.personaId === personaId)?.map(r => r.rolId)
    return rolesForUser || []
  };
  const getNombresRoles = (rolesId) => {
    let rolesNombres = (roles || [])?.filter(rol => rolesId.includes(rol.rolId))?.map(r => r.nombre)
    return rolesNombres || []
  };
  const getPersonaContratoFirmado = (personaId) => {
    let personaTitularidades = (titularidades || [])?.filter(t => t.personaId === personaId)?.map(c => c.contratoId)
    let personaContratos = (contratos || [])?.filter(c => personaTitularidades?.includes(c.contratoId))
    let contratoFirmado = personaContratos?.find(c => c.fechaFirma !== null)
    return contratoFirmado ? true : false
  };
  const getPersonaContratoPerfeccionado = (personaId) => {
    let personaTitularidades = (titularidades || [])?.filter(t => t.personaId === personaId)?.map(c => c.contratoId)
    let personaContratos = (contratos || [])?.filter(c => personaTitularidades?.includes(c.contratoId))
    let contratoFirmado = personaContratos?.find(c => c.fechaPerfeccionamiento !== null)
    return contratoFirmado ? true : false
  };
  function isEditButtonDisabled(rowId) {
    const isCurrentUserWriteGerenciaEmpresa = currentUser?.permisos?.includes('writeGerenciaEmpresa');
    const isCurrentUserWriteStaffEmpresa = currentUser?.permisos?.includes('writeStaffEmpresa');
    const isPersonaGerencia = getNombresRoles(getPersonaRolesId(rowId)).some(role => ['Gerente', 'Socio', 'Admin'].includes(role))
    const rolesPersona = getNombresRoles(getPersonaRolesId(rowId));
    const hasPersonaContratoFirmado = getPersonaContratoFirmado(rowId)
    const hasPersonaContratoPerfeccionado = getPersonaContratoPerfeccionado(rowId);
    const isCurrentUserVendedorExterno = currentUser?.roles?.includes('Vendedor Externo');
    const isCurrentUserAdminCartera = currentUser?.roles?.includes('Administrador de Cartera');
    const isCurrentUserEjecutivoCuentas = currentUser?.roles?.includes('Ejecutivo de Cuentas');
    const isCurrentUserJefeVendedores = currentUser?.roles?.includes('Jefe Vendedores');
    const isCurrentUserAdministrativo = currentUser?.roles?.includes('Administrativo');

    return (
      (!isCurrentUserWriteGerenciaEmpresa && isPersonaGerencia) ||
      (!isCurrentUserWriteStaffEmpresa && (rolesPersona?.length === 1 && rolesPersona[0] !== 'Ahorrista')) ||
      (hasPersonaContratoFirmado &&
        (isCurrentUserVendedorExterno ||
          isCurrentUserAdminCartera ||
          isCurrentUserEjecutivoCuentas ||
          isCurrentUserJefeVendedores))
    );
  };
  function isDeleteButtonDisabled(rowId) {
    const isUserDeleted = showDeletedUsers;
    const isCurrentUserWriteGerenciaEmpresa = currentUser?.permisos?.includes('writeGerenciaEmpresa');
    const isCurrentUserWriteStaffEmpresa = currentUser?.permisos?.includes('writeStaffEmpresa');
    const isPersonaGerencia = getNombresRoles(getPersonaRolesId(rowId)).some(role => ['Gerente', 'Socio', 'Admin'].includes(role))
    const rolesPersona = getNombresRoles(getPersonaRolesId(rowId));
    const hasPersonaContratoFirmado = getPersonaContratoFirmado(rowId)
    const hasPersonaContratoPerfeccionado = getPersonaContratoPerfeccionado(rowId);
    const isCurrentUserVendedorExterno = currentUser?.roles?.includes('Vendedor Externo');
    const isCurrentUserAdminCartera = currentUser?.roles?.includes('Administrador de Cartera');
    const isCurrentUserEjecutivoCuentas = currentUser?.roles?.includes('Ejecutivo de Cuentas');
    const isCurrentUserJefeVendedores = currentUser?.roles?.includes('Jefe Vendedores');
    const isCurrentUserAdministrativo = currentUser?.roles?.includes('Administrativo');

    return (
      isUserDeleted ||
      (!isCurrentUserWriteGerenciaEmpresa &&
        isPersonaGerencia)) ||
      (!isCurrentUserWriteStaffEmpresa && (rolesPersona?.length === 1 && rolesPersona[0] !== 'Ahorrista')) ||
      (hasPersonaContratoFirmado &&
        (isCurrentUserVendedorExterno ||
          isCurrentUserAdminCartera ||
          isCurrentUserEjecutivoCuentas ||
          isCurrentUserJefeVendedores)) ||
      (hasPersonaContratoPerfeccionado &&
        (isCurrentUserVendedorExterno ||
          isCurrentUserAdminCartera ||
          isCurrentUserEjecutivoCuentas ||
          isCurrentUserJefeVendedores ||
          isCurrentUserAdministrativo))

  };

  const Header = () => {
    const fetching = useSelector(state => state.personas.fetching);
    return (<Fragment>
      <Typography
        variant="h5"
        component="div"
        sx={{
          minWidth: 275, margin: "10px",
          display: 'flex',
          alignItems: 'center'
        }}
      >
        {type === 'juridicas' ?
          <BalanceIcon sx={{ marginRight: '5px', color: theme.palette.secondary.dark }} />
          : <PersonIcon sx={{ marginRight: '5px', color: theme.palette.secondary.dark }} />
        }
        {type === 'juridicas' ? 'Personas Jurídicas' : 'Personas Humanas'}
      </Typography>
      {fetching > 0 && <p>Cargando</p>}
    </Fragment>);
  };

  function handleDelete(personaId) {
    console.log(personaId, 'delete')
    dispatch(deletePersona([personaId])).unwrap()
      .then((result) => {
        console.log('result', result);
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  function getDropdownOptions(soloFisicas) {
    let personasAsArray = (personas || []);
    if (soloFisicas) {
      personasAsArray = personasAsArray.filter(p => p.personaFisica);
    }
    return personasAsArray.map(p => ({ id: p.personaId, label: getLabel(p) }));
  };
  const handleRegisterConfirmation = (params) => {

    let registeredPersona = {
      ...params, activo: !params.activo
    }
    delete registeredPersona?.password
    currentUser.permisos.includes('altaPersona') ?
      dispatch(editPersona(registeredPersona))
        .then(console.log)
        .catch(console.error)
      : console.log('Acceso denegado.')
    setUserRegisterModal(false)
    return null;
  };
  const UserMoreDetailsModal = () => {
    function DetallesUsuario() {
      const [showDen, setShowDen] = useState(false)
      let permisosChange = [...permisos.map(p => ({ ...p, descripcion: p.descripcion.replace('Puede ', '')[0].toUpperCase() + p.descripcion.replace('Puede ', '').substring(1) }))]
      let rolesUser = (rolesMap || []).filter(rolMap => rolMap.personaId === userMoreDetail.personaId);
      let permisosRoles = []
      rolesUser.forEach(r => permisosRoles = (permisosChange?.filter(p => permisosRolesMap?.filter(prm => prm.rolId === r.rolId)?.map(prm => prm.permisoId)?.includes(p.permisoId))))
      let permisosDen = permisosChange?.filter(p => !(permisosRoles?.map(pr => pr.permisoId).includes(p.permisoId)))?.map(p => p.descripcion)

      let accesos = []
      let lecturas = []
      let escrituras = []
      permisosRoles?.map(p => p.descripcion).forEach(p => {
        p.startsWith('Ver') ? lecturas.push(p) : (p.startsWith('Eliminar') || p.startsWith('Crear')) || (p.startsWith('Editar') || p.startsWith('Generar')) ? escrituras.push(p) : accesos.push(p)
      });
      let accesosDen = []
      let lecturasDen = []
      let escriturasDen = []
      permisosDen?.forEach(p => {
        p.startsWith('Ver') ? lecturasDen.push(p) : (p.startsWith('Eliminar') || p.startsWith('Crear')) || (p.startsWith('Editar') || p.startsWith('Generar')) ? escriturasDen.push(p) : accesosDen.push(p)
      });
      return (
        <>
          {rolesUser?.map(rolMap => {
          const rolNombre = (roles || [])?.find(r=> r.rolId === rolMap.rolId).nombre
          return(<Typography key={`typo-${rolMap.rolId}`} variant="h5" label={rolNombre} style={{ 'marginBottom': '20px', 'marginLeft': '5px' }} >
            {rolNombre} </Typography>)})}
          <Grid container display='flex'>
            <Grid item xs={2.5} sx={{ marginBottom: '10px' }}>
              <Typography sx={{ marginLeft: '0px', marginRight: '5px', marginTop: '9px' }} >Ver permisos denegados</Typography>
            </Grid>
            <Grid item xs={1.2}  >
              <Switch sx={{ marginTop: '10px' }} label={`Switch permisos den ${userMoreDetail.personaId}`} size="small" color="secondary" disabled={permisosDen?.length === 0} onChange={() => setShowDen(!showDen)} />
            </Grid>
          </Grid>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${accesos}a-content`}
              id={`panel${accesos}a-header`}
              alignItems="center"
            >
              <VpnKeyIcon sx={{ marginRight: '11px' }} color={showDen ? 'secondary' : 'primary'}></VpnKeyIcon>
              <Typography sx={{ marginRight: '11px' }} > Accesos ({(showDen ? accesosDen : accesos).length})</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={0} display='flex' flexWrap='wrap'>
                {(showDen ? accesosDen : accesos)?.map((permisoLabel, i) =>
                  <Grid key={`gridaccesos${permisoLabel}${userMoreDetail.personaId}`} item sx={{ minWidth: '300px', maxWidth: '300px', marginLeft: '20px' }}>
                    <Typography ><FiberManualRecordIcon color={showDen ? 'secondary' : 'primary'} sx={{ paddingTop: '8px' }} fontSize='small' />{permisoLabel}</Typography>
                  </Grid>
                )}
              </Grid>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${lecturas}a-content`}
              id={`panel${lecturas}a-header`}
              alignItems="center"
            >
              <VisibilityIcon sx={{ marginRight: '11px' }} color={showDen ? 'secondary' : 'primary'}></VisibilityIcon>
              <Typography sx={{ marginRight: '11px' }}>Lecturas ({(showDen ? lecturasDen : lecturas).length})</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={0} display='flex' flexWrap='wrap'>
                {(showDen ?
                  lecturasDen : lecturas).map(permisoLabel =>
                    <Grid key={`gridlecturas${permisoLabel}${userMoreDetail.personaId}`} item sx={{ minWidth: '300px', maxWidth: '300px', marginLeft: '20px' }}>
                      <Typography ><FiberManualRecordIcon color={showDen ? 'secondary' : 'primary'} sx={{ paddingTop: '8px' }} fontSize='small' />{permisoLabel}</Typography>
                    </Grid>
                  )}
              </Grid>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${escrituras}a-content`}
              id={`panel${escrituras}a-header`}
              alignItems="center"
            >
              <EditIcon sx={{ marginRight: '11px' }} color={showDen ? 'secondary' : 'primary'}></EditIcon>
              <Typography sx={{ marginRight: '11px' }}>Escrituras ({(showDen ? escriturasDen : escrituras).length})</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={0} display='flex' flexWrap='wrap'>
                {(showDen ? escriturasDen : escrituras)?.map((permisoLabel, i) =>
                  <Grid key={`gridescrituras${permisoLabel}${userMoreDetail.personaId}`} item sx={{ minWidth: '300px', maxWidth: '300px', marginLeft: '20px' }}>
                    <Typography > <FiberManualRecordIcon color={showDen ? 'secondary' : 'primary'} sx={{ paddingTop: '8px' }} fontSize='small' /> {permisoLabel}</Typography>
                  </Grid>
                )}
              </Grid>
            </AccordionDetails>
          </Accordion>

        </>
      )
    }

    function ContratosUsuario() {
      const inf = (useSelector(state => state?.contratos?.infoContrato) || []);
      console.log('inf', inf)
      let contratosDeUsuarioMap = (titularidades || [])?.filter(t=> t.personaId === userMoreDetail.personaId)?.map(contratoMap => contratoMap.contratoId)//useSelector((state) => selectTitularidadByUserId(state, userMoreDetail.personaId));
      let contratosDeUsuario = inf//(contratos || [])?.filter(c=> contratosDeUsuarioMap?.includes(c.contratoId)) 

      function AccordionContrato({ contrato }) {
        function AccordionTitle({ title, progressValue }) {
          return (
            <Grid container spacing={2}>
              <Grid item xs={6}>
              <Typography children={title} fontWeight={'bold'}  sx={{ color: theme.palette.secondary.dark, fontSize: 18  }} />
              </Grid>
              <Grid item xs={6}>
              <Typography children={`Titularidad: ${progressValue.toFixed(2)} % `} fontWeight={'bold'}  sx={{ color: theme.palette.secondary.dark, fontSize: 18  }} />
                
              </Grid>
            </Grid>
          )
        };
        console.log('contrato', contrato)
        let { contratoId, mesRefuerzoSemestral1, mesRefuerzoSemestral2, fechaCreacion, adelantoInicialNominal } = contrato?.contrato;
        let historia = contrato?.historia
        let refuerzo = mesRefuerzoSemestral1 !== null ? 'Semestral' : 'Prorrateado';
        let claseContrato = _.last(historia)?.claseContratoActual;
        const { estado } = _.last(historia)
        const valorContratoCAC = estado?.adelantoInicialAcumCAC + estado?.adelantoInicialBonifAcumCAC + estado?.ofertaLicitatoriaAcumCAC
          + estado?.ofertaLicitatoriaBonifAcumCAC + estado?.cuotaEsperaAcumCAC + estado?.cuotaEsperaBonifAcumCAC
          + estado?.primaAcumCAC + estado?.cuotaPrimaBonifAcumCAC + estado?.cuotaPosesionAcumCAC
          + estado?.adelantoRecurrenteAcumCAC + estado?.adelantoRecurrenteBonifAcumCAC + estado?.adelantoEspontaneoAcumCAC
          + estado?.adelantoEspontaneoBonifAcumCAC + estado?.refuerzoSemestralCuotaEsperaAcumCAC + estado?.refuerzoSemestralCuotaEsperaBonifAcumCAC
          + estado?.refuerzoSemestralAdelantoRecurrenteAcumCAC + estado?.refuerzoSemestralAdelantoRecurrenteBonifAcumCAC;
        let valor = getConversionesCAC(valorContratoCAC, estado?.indice, claseContrato);
        let porcentajeTitularidad = contrato?.titularidades?.find(c=> c.personaId === userMoreDetail.personaId).partes;
        return (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${contratoId}a-content`}
              id={`panel${contratoId}a-header`}
            >
              <AccordionTitle title={`${claseContrato.descripcion} ID: ${contratoId} `} progressValue={porcentajeTitularidad} />
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                <List>
                  <Grid container spacing={2}>
                    <Grid xs={6}>
                      <ListItem>
                        <ListItemText primary={`Fecha de Creación: ${getFecha(fechaCreacion)}`} />
                      </ListItem>
                    </Grid>
                    
                    <Grid xs={6}>
                      <ListItem>
                        <ListItemText primary={`Refuerzo: ${refuerzo}`} />
                      </ListItem>
                    </Grid>
                    <Grid xs={6}>
                      <ListItem>
                        <ListItemText primary={`Adelanto Inicial Nominal: ${moneyFormat(adelantoInicialNominal)}`} />
                      </ListItem>

                    </Grid>
                    <Grid xs={6}>

                      <ListItem>
                        <ListItemText primary={`Grado de avance: ${(valor?.ga * 100)?.toFixed(2)}%`} />
                      </ListItem>
                    </Grid>
                    <Grid xs={6}>

                    </Grid>
                    <Grid xs={6}>

                    </Grid>
                  </Grid>

                </List>

              </Typography>
            </AccordionDetails>
          </Accordion>
        )
      }
      return (
        <>
          <div>
            {contratosDeUsuario.map(contrato => <AccordionContrato key={`acordion-contrato${contrato.contrato.contratoId}`} contrato={contrato} />)}
          </div>
        </>
      )
    }

    function TabPanel(props) {
      const { children, value, index, ...other } = props;

      return (
        <div
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
        >
          {value === index && (
            <Box sx={{ p: 3 }}>
              <Typography>{children}</Typography>
            </Box>
          )}
        </div>
      );
    }

    const ModalTabs = () => {
      function a11yProps(index) {
        return {
          id: `simple-tab-${index}`,
          'aria-controls': `simple-tabpanel-${index}`,
        };
      }

      const [value, setValue] = useState(0);

      const handleChange = (event, newValue) => {
        setValue(newValue);
      };

      return (
        <>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab sx={{ fontWeight: "bold" }} label="Permisos" {...a11yProps(0)} />
              <Tab sx={{ fontWeight: "bold" }} label="Contratos" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <DetallesUsuario />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <ContratosUsuario />
          </TabPanel>
        </>
      )
    }

    return (
      <Dialog
        open={userMoreDetail}
        onClose={() => setUserMoreDetail(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        maxWidth='lg'
      >
        <DialogTitle id="alert-dialog-title" fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>
          Detalles del usuario {userMoreDetail ? getLabel(userMoreDetail) : ''}
        </DialogTitle>

        <DialogContent dividers>
          <ModalTabs />
        </DialogContent>

        <DialogActions>
          <Button sx={{ fontWeight: "bold" }} variant="outlined" onClick={() => setUserMoreDetail(null)}>Volver</Button>
        </DialogActions>
      </Dialog>
    )
  };
  const UserRegisterConfirmationModal = () => {

    let persona = (personas || [])?.find(p => p.personaId === userRegisterModal?.personaId)

    return (
      <Dialog
        open={userRegisterModal}
        onClose={() => setUserMoreDetail(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        maxWidth='sm'
      >
        <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }} id="alert-dialog-title">
          {userRegisterModal?.activo ? `¿Dar de baja al usuario ${userRegisterModal ? getLabel(userRegisterModal) : ''}?` :
            ` ¿Dar de alta al usuario ${userRegisterModal ? getLabel(userRegisterModal) : ''}?`}
        </DialogTitle>
        <DialogContent dividers>
          <Typography></Typography>
          <Typography>
            {userRegisterModal?.activo ? `Una vez confirmada la acción, se le negará el acceso al usuario en el portal.` :
              `Se enviará un mail de acceso al usuario. Una vez confirmada la acción, no podrá deshacerse.`}
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button sx={{ fontWeight: "bold" }} variant="outlined" onClick={() => setUserRegisterModal(null)}>Cancelar</Button>
          <Button sx={{ fontWeight: "bold", color: "white" }} variant='contained' autoFocus onClick={() => handleRegisterConfirmation(persona)}>Confirmar</Button>
        </DialogActions>
      </Dialog>
    )
  };
  const Notification = (props) => {
    const [showNotification, setShowNotification] = useState(true);
    const onClose = () => setShowNotification(false);
    return (<>{error || message ? 
    <Snackbar fullWidth anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={showNotification} autoHideDuration={6000} onClose={onClose} >
      <Alert sx={{ bgcolor: 'background.paper', fontWeight: 'bold' }} severity={error ? 'error' : 'success'} variant={'outlined'} fullWidth>
       <Typography color={'primary'} fontWeight={'bold'} children={error ? error : message} />
      </Alert>
    </Snackbar>: null }</>)
  }
  return (
    <Fragment>
      <Header></Header>
      <UserMoreDetailsModal />
      <UserRegisterConfirmationModal />
      <Notification />
      {type === 'juridicas' ?
        <PersonasJuridicasTable
          TIPOS_DNI={TIPOS_DNI}
          handleRegisterConfirmation={handleRegisterConfirmation}
          addPersona={addPersona}
          setUserMoreDetail={setUserMoreDetail}
          rolesMap={rolesMap || []}
          roles={roles || []}
          personas={personasJuridicas || []}
          editPersona={editPersona}
          getLabel={getLabel}
          getDropdownOptions={getDropdownOptions}
          isEditButtonDisabled={isEditButtonDisabled}
          isDeleteButtonDisabled={isDeleteButtonDisabled}
          showDeletedUsers={showDeletedUsers}
          deletePersona={deletePersona}
          handleDelete={handleDelete}
          handleSwitchChange={handleSwitchChange}
          setUserRegisterModal={setUserRegisterModal}
          fetching={fetching}
          message={message}
          error={error}
        /> :
        <PersonasHumanasTable
          TIPOS_DNI={TIPOS_DNI}
          handleRegisterConfirmation={handleRegisterConfirmation}
          addPersona={addPersona}
          setUserMoreDetail={setUserMoreDetail}
          rolesMap={rolesMap || []}
          roles={roles || []}
          titularidades={titularidades || []}
          contratos={contratos || []}
          personas={personasHumanas || []}
          editPersona={editPersona}
          getLabel={getLabel}
          getDropdownOptions={getDropdownOptions}
          isEditButtonDisabled={isEditButtonDisabled}
          isDeleteButtonDisabled={isDeleteButtonDisabled}
          showDeletedUsers={showDeletedUsers}
          deletePersona={deletePersona}
          handleDelete={handleDelete}
          handleSwitchChange={handleSwitchChange}
          setUserRegisterModal={setUserRegisterModal}
          fetching={fetching}
          message={message}
          error={error}
        />}

    </Fragment>
  )
};

export default PersonasCat;